import { render } from "./PostDrop.vue?vue&type=template&id=4bfcfa1b&scoped=true"
import script from "./PostDrop.vue?vue&type=script&lang=js"
export * from "./PostDrop.vue?vue&type=script&lang=js"

import "./PostDrop.vue?vue&type=style&index=0&id=4bfcfa1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfcfa1b"]])

export default __exports__